import React from "react";
import { Grid, Paper, Typography } from "@material-ui/core";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  deBaja: {
    backgroundColor: "red",
    paddingLeft: 25,
  },
  deAlta: {
    backgroundColor: "green",
    paddingLeft: 25,
  },
  disca: {
    backgroundColor: "#4FE3E3",
    paddingLeft: 25,
  },
  sinFicha: {
    backgroundColor: "#FFFF00",
    paddingLeft: 25,
  },
  divContenedor: {
    display: "flex",
    justifyContent: "space-between",
  },
  turnos: {
    fontSize: 14
  },
  contratos: {
    fontSize: 17,
    color: "white"
  },
}));

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

const fechaActual = new Date();

export const BannerAfiliado = ({ fromPreafiliaciones = false, turnos, contratos, consulta }) => {
  const classes = useStyles();
  const afiliacion = useSelector((state) => state.afiliacion);
  const { consultaAfiliado} = useSelector((state) => state.afiliacion);
  const preinscripto = useSelector((state) => state.preinscripto);
  const afiliado = fromPreafiliaciones ? preinscripto.afiliadoEncontrado : afiliacion.afiliado;

  const seccional = useSelector(state =>
    state.seccionales.items.find((sec) => sec?.id_seccional === afiliado?.domiciliosAfiliados?.id_seccional)
  );
  const categoria = useSelector(state =>
    state.categorias.items.find((cat) => cat?.id_sr === afiliado?.id_sit_revista)
  );

  
  const seccionalConsulta = useSelector(state =>
    state.seccionales.items.find((sec) => sec?.id_seccional === consultaAfiliado?.domiciliosAfiliados?.id_seccional)
  );
  const categoriaConsulta = useSelector(state =>
    state.categorias.items.find((cat) => cat?.id_sr === consultaAfiliado?.id_sit_revista)
  );
  
  const { dataContrato } = useSelector((state) => state.contrataciones);

  return (
    <>
      <Grid container className={classes.divContenedor} spacing={1}>
        {!contratos && !consulta &&
          <>
            <Grid item xs={turnos ? (afiliado?.fecha_baja ? 8 : 12) : 6}>
              <Paper
                className={afiliado?.fecha_baja ? classes.deBaja : (afiliado?.sinFichaAfiliacion ? classes.sinFicha : (afiliado?.incapacitado === 1 ? classes.disca : classes.deAlta))}
                style={turnos && { paddingLeft: 0, textAlign: 'center' }}
                component={"div"}
                elevation={1}
              >
                <Typography
                  style={{
                    color: afiliado?.incapacitado === 1 || afiliado?.sinFichaAfiliacion ? "#000000" : "#FFFFFF",
                  }}
                  variant={turnos ? 'h6' : "subtitle1"}
                  component={turnos ? 'h5' : "p"}
                  className={turnos && classes.turnos}
                >
                  {turnos && afiliado?.fecha_baja
                    ?
                    `${afiliado?.apellido_y_nombre.substr(0, 33)} / CUIL: ${afiliado?.cuil}`
                    :
                    (afiliado.sinFichaAfiliacion ?
                      `${afiliado?.apellido_y_nombre} / CUIL: ${afiliado?.cuil} / (Sin Ficha: ${afiliado?.motivoSinFicha?.descripcion})`
                      :
                      `${afiliado?.apellido_y_nombre} / CUIL: ${afiliado?.cuil}`)
                  }
                </Typography>
              </Paper>
            </Grid>
          </>
        }
        {consulta &&
          <>
            <Grid item xs={turnos ? (consultaAfiliado?.fecha_baja ? 8 : 12) : 6}>
              <Paper
                className={consultaAfiliado?.fecha_baja ? classes.deBaja : (consultaAfiliado?.sinFichaAfiliacion ? classes.sinFicha : (consultaAfiliado?.incapacitado === 1 ? classes.disca : classes.deAlta))}
                style={{ paddingLeft: "1rem" }}
                component={"div"}
                elevation={1}
              >
                <Typography
                  style={{
                    color: consultaAfiliado?.sinFichaAfiliacion || consultaAfiliado?.incapacitado === 1 ? "#000000" : "#FFFFFF",
                  }}
                  variant={turnos ? 'h6' : "subtitle1"}
                  component={turnos ? 'h5' : "p"}
                  className={turnos && classes.turnos}
                >
                  {afiliado?.fecha_baja
                    ?
                    `${consultaAfiliado?.apellido_y_nombre.substr(0, 33)} / CUIL: ${consultaAfiliado?.cuil}`
                    :
                    (consultaAfiliado.sinFichaAfiliacion ?
                      `${consultaAfiliado?.apellido_y_nombre} / CUIL: ${consultaAfiliado?.cuil} / (Sin Ficha: ${consultaAfiliado?.motivoSinFicha?.descripcion})`
                      :
                      `${consultaAfiliado?.apellido_y_nombre} / CUIL: ${consultaAfiliado?.cuil}`)
                  }
                </Typography>
              </Paper>
            </Grid>
          </>
        }
        {turnos && afiliado?.fecha_baja &&
          <Grid item xs={4}>
            <Paper
              className={classes.deBaja}
              style={{ paddingLeft: 0, textAlign: 'center' }}
              component={"div"}
              elevation={1}
            >
              <Typography
                style={{
                  color: "#FFFFFF",
                }}
                className={classes.turnos}
                variant="h6"
                component="h5"
              >
                {`Fecha Baja: ${new Date(afiliado?.fecha_baja).toLocaleString(
                  "es",
                  optionsfecha
                )}`}
              </Typography>
            </Paper>
          </Grid>
        }
        {consulta &&
          <>
            <Grid item xs={3}>
              <Paper
                className={consultaAfiliado?.fecha_baja ? classes.deBaja : (consultaAfiliado?.sinFichaAfiliacion ? classes.sinFicha : (consultaAfiliado?.incapacitado === 1 ? classes.disca : classes.deAlta))}
                component={"div"}
                elevation={1}
              >
                <Typography
                  style={{
                    color: consultaAfiliado?.incapacitado === 1 || consultaAfiliado?.sinFichaAfiliacion ? "#000000" : "#FFFFFF",
                  }}
                  variant="subtitle1"
                >
                  {seccionalConsulta && `Seccional: ${seccionalConsulta?.descripcion_seccional}`}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={3}>
              <Paper
                className={consultaAfiliado?.fecha_baja ? classes.deBaja : (consultaAfiliado?.sinFichaAfiliacion ? classes.sinFicha : (consultaAfiliado?.incapacitado === 1 ? classes.disca : classes.deAlta))}
                component={"div"}
                elevation={1}
              >
                <Typography
                  style={{
                    color: consultaAfiliado?.incapacitado === 1 || consultaAfiliado?.sinFichaAfiliacion ? "#000000" : "#FFFFFF",
                  }}
                  variant="subtitle1"
                >
                  {categoriaConsulta && `Categ.: ${categoriaConsulta?.descripcion_sr}`}
                </Typography>
              </Paper>
            </Grid>
          </>
        }
        {!turnos && !contratos &&
          <>
            <Grid item xs={3}>
              <Paper
                className={afiliado?.fecha_baja ? classes.deBaja : (afiliado?.sinFichaAfiliacion ? classes.sinFicha : (afiliado?.incapacitado === 1 ? classes.disca : classes.deAlta))}
                component={"div"}
                elevation={1}
              >
                <Typography
                  style={{
                    color: afiliado?.incapacitado === 1 || afiliado?.sinFichaAfiliacion ? "#000000" : "#FFFFFF",
                  }}
                  variant="subtitle1"
                >
                  {seccional && `Seccional: ${seccional?.descripcion_seccional}`}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={3}>
              <Paper
                className={afiliado?.fecha_baja ? classes.deBaja : (afiliado?.sinFichaAfiliacion ? classes.sinFicha : (afiliado?.incapacitado === 1 ? classes.disca : classes.deAlta))}
                component={"div"}
                elevation={1}
              >
                <Typography
                  style={{
                    color: afiliado?.incapacitado === 1 || afiliado?.sinFichaAfiliacion ? "#000000" : "#FFFFFF",
                  }}
                  variant="subtitle1"
                >
                  {categoria && `Categ.: ${categoria?.descripcion_sr}`}
                </Typography>
              </Paper>
            </Grid>
          </>
        }
        {contratos &&
          <Grid item xs={12}>
            <Paper
              className={dataContrato?.fechaBaja ? classes.deBaja : classes.deAlta}
              style={contratos && { paddingLeft: 20, textAlign: 'left' }}
              component={"div"}
              elevation={1}
            >
              <Typography
                variant={contratos ? 'h6' : "subtitle1"}
                component={contratos ? 'h5' : "p"}
                className={contratos && classes.contratos}
              >
                {contratos && dataContrato?.fechaBaja && dataContrato?.fechaBaja <= fechaActual
                  ?
                  `NRO CONTRATO: ${dataContrato?.idEfectorFacturacion} - RAZON SOCIAL: ${dataContrato?.razonSocial.substr(0, 33)} - CUIT: ${dataContrato?.cuit}`
                  :
                  `NRO CONTRATO: ${dataContrato?.idEfectorFacturacion} - RAZON SOCIAL: ${dataContrato?.razonSocial} - CUIT: ${dataContrato?.cuit}`
                }
              </Typography>
            </Paper>
          </Grid>
        }
      </Grid>
    </>
  );
};